module.exports = "\n<div class=\"popover\">\n  <div  class=\"popover_inner\">\n    <div @click=\"closePopup\" class=\"popover_close\">Close X</div>\n    <slot></slot>\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover.vue
 ** module id = 23
 ** module chunks = 1
 **/